import { connect } from "react-redux";
import { ItemUpdateHistory } from "../shared/ItemUpdateHistory";
import { getItemUpdateTasks } from "../../app/store/actions/imsWarehouseStaffActions";

const WHItemUpdateHistory = (props) => (
    <ItemUpdateHistory
        {...props}
        progressBase="/ims/warehouse-staff/item-updates"
        homePath="/ims/warehouse-staff"
    />
);

const mapStateToProps = (state) => ({
    isLoading: state?.records?.isLoading,
    itemUpdateTasks: state?.records?.itemUpdateTasks,
});

export default connect(mapStateToProps, { getItemUpdateTasks })(WHItemUpdateHistory);
